import jquery from 'jquery';
import $ from 'jquery';
import gsap from 'gsap';

import Slider from './slider'
import About from './about'

import { btnFade } from './utils';


class App {
    constructor() {
        this.$text1Preloader = $('.cont-text-line1-preloader');
        this.$text2Preloader = $('.cont-text-line2-preloader');
        this.$text3Preloader = $('.cont-text-line3-preloader');
        this.$linePreloader = $('.line-preloader');

        this.slider = new Slider();
        this.about = new About();

        this.tl = new TimelineMax({
            paused: true,
            delay: 1,
            onComplete: () => {

                this.slider.init();
                this.about.init();

                // btnFade('.cover-preloader', '1');
                TweenMax.to('.cover-preloader', 0.6, {
                    autoAlpha: 0,
                    ease: Power3.easeInOut
                });
                TweenMax.to('.line-btn-animation', 0.6, { width: '100%', ease: Power3.easeInOut });
                TweenMax.to('#arrow-btn-example', 0.6, { width: '130px', right: 0, ease: Power3.easeInOut, delay: 1.2 });

            }
        });

        this.createAnimation();
    }

    init() {

        gsap.set(this.$text1Preloader, { opacity: 0 });
        gsap.set(this.$text2Preloader, { opacity: 0 });
        gsap.set(this.$text3Preloader, { opacity: 0 });

        this.tl.play();

    }

    createAnimation() {
        this.tl.to('.stripes--top', 0.8, {
            xPercent: 100,
            ease: Expo.easeOut
        }).to('.stripes--bottom', 0.8, {
            xPercent: -100,
            ease: Expo.easeOut
        }, '-=0.6').staggerTo(this.$linePreloader, 0.6, {
            left: 0,
            ease: Expo.easeOut,
        }, 0.4).from(this.$text1Preloader, 0.4, {
            marginTop: '70px',
            opacity: 0,
            ease: Expo.easeOut,
            delay: 0.1
        }, 1.3).add('returnLine').from(this.$text2Preloader, 0.4, {
            opacity: 0,
            marginTop: '70px',
            ease: Expo.easeOut,
            delay: 0.1
        }, 1.7).from(this.$text3Preloader, 0.4, {
            opacity: 0,
            marginTop: '70px',
            ease: Expo.easeOut,
            delay: 0.1
        }, 2.1).to(this.$text1Preloader, 0.6, {
            marginLeft: '105%',
            opacity: 0.3,
            ease: Expo.easeOut,
            delay: 0.1
        }, 2.8).to(this.$text2Preloader, 0.6, {
            marginLeft: '105%',
            opacity: 0.3,
            ease: Expo.easeOut,
            delay: 0.1
        }, 3.2).to(this.$text3Preloader, 0.5, {
            marginLeft: '105%',
            opacity: 0.3,
            ease: Expo.easeOut
        }, '-=0.2').staggerTo(this.$linePreloader, 0.4, {
            left: '100%',
            width: 0,
            ease: Power4.easeIn,
            delay: 0.1
        }, 0.4, 'returnLine');
    }
}

export default App;



/** WEBPACK FOOTER **
 ** ./components/app.js
 **/